import { SxProps, Theme } from '@mui/material/styles';

export const popperSx: SxProps<Theme> = {
  zIndex: 2,
  right: '0 !important',
  transform: 'none !important',
  top: '36px !important',
};
